module.exports = __webpack_public_path__ + "e28ae6c5b2dbc074fc3b0f77fafac463.jpg";